// extracted by mini-css-extract-plugin
module.exports = {"img":"SlideImg_img__1Oi75"};